// extracted by mini-css-extract-plugin
export default {"loader-box":"Loader_loader-box__U+MQB","loader":"Loader_loader__A+gdx"};